export default "__VITE_ASSET__Ds0R9s0u__"